exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formsection[data-v-393f5c6d]{display:flex;flex-direction:column;width:100%;padding:0;border:none;margin:0 0 .625rem;min-inline-size:0}.formsection__header[data-v-393f5c6d]{margin-bottom:1.25rem}.formsection__header__title[data-v-393f5c6d]{width:100%;font-size:1.25rem;font-weight:500;padding-bottom:.375rem;color:#2f2f2f;border-bottom:1px solid #dcdada;box-sizing:border-box}.formsection__header__desc[data-v-393f5c6d]{margin-top:.625rem}", ""]);

// exports
